import { MouseEventHandler, useEffect, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import NextLink from "next/link";
import useSWR from "swr";
import { PropertyImageData } from "commonModule/services/common";
import { FALLBACK_LOGO_IMAGE } from "constant";
import { apiClientCommon } from "services/apiClientCommon";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
import LazyLoadedImage from "./LazyLoadedImage";
const fetcher = async ({
  propertyId
}: {
  propertyId: string | number;
}) => {
  const res = await apiClientCommon.getPropertyImages({
    params: {
      propertyId
    }
  });
  return res?.data?.data || [];
};
const PropertyImageSlider = ({
  propertyId,
  images = [],
  loading = "eager",
  afterChange = () => {},
  propertyUrl = "",
  onClick,
  defaultAlt,
  className = "",
  imageClassName = "",
  isDragOnDesktop = true
}: {
  propertyId: string;
  images: PropertyImageData[];
  loading?: "eager" | "lazy";
  afterChange?: (index: number) => void;
  propertyUrl: string;
  onClick?: MouseEventHandler<HTMLAnchorElement> | undefined;
  defaultAlt?: string;
  className?: string;
  imageClassName?: string;
  isDragOnDesktop?: boolean;
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const {
    data = images
  } = useSWR(currentSlide >= 2 ? {
    propertyId
  } : null, fetcher);
  useEffect(() => {
    const svgArrows = document.querySelectorAll(".search-mobile-slider-container .splide__arrow svg");
    svgArrows.forEach(svg => {
      svg.setAttribute("aria-hidden", "true");
    });
  }, []);
  return <div className='search-mobile-slider-container relative aspect-[500/455] h-full w-full overscroll-contain rounded-lg bg-gray-100' data-sentry-component="PropertyImageSlider" data-sentry-source-file="PropertyImageSlider.tsx">
      <Splide id={`image-slider-${propertyId}`} options={{
      type: "fade",
      perPage: 1,
      padding: 0,
      drag: isLargerThan768 ? isDragOnDesktop : false,
      // for mouse dragging
      swipe: isLargerThan768 ? isDragOnDesktop : false,
      // for touch swiping
      heightRatio: 455 / 500,
      pagination: false,
      arrows: true
    }} onMove={(_, currentSlideIndex) => {
      afterChange?.(currentSlideIndex);
      setCurrentSlide(currentSlideIndex);
    }} onMoved={(_, currentSlideIndex) => {
      setCurrentSlide(currentSlideIndex);
      const el = document.querySelector(`#image-slider-${propertyId} .splide__pagination__page.is-active`);
      el?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }} data-sentry-element="Splide" data-sentry-source-file="PropertyImageSlider.tsx">
        {data?.map((attachment, i) => <SplideSlide key={`attachment${i}`} className={className}>
            <NextLink className='w-full' onClick={onClick} href={propertyUrl} target={isLargerThan768 ? "_blank" : "_self"} aria-label='View property details'>
              <LazyLoadedImage src={attachment?.image_full_url ?? FALLBACK_LOGO_IMAGE} alt={defaultAlt || `property-image-slider-${i}`} className={`block aspect-[511/345] h-full w-full rounded-lg object-cover text-transparent ${imageClassName}`} loading={loading} isLazy={i > 1} readyToLoad={Math.abs(currentSlide - i) <= 1} readyToLoadHighRes={currentSlide === i} />
            </NextLink>
          </SplideSlide>)}
      </Splide>
    </div>;
};
export default PropertyImageSlider;